import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./page/home";
import Navbar from "./components/shared/navbar";
import Footer from "./components/shared/footer";
import Reviews from "./components/review/reviews";
import Products from "./components/products/products";
import Faqs from "./components/faq/faqs";
import Becomedealerpage from "./page/becomedealerpage";
import Privacypolicy from "./components/privacy/privacypolicy";
import Terms from "./components/termsandconditions/terms";
import Contact from "./page/contact";
import Repairs from "./components/repair/repairs";
import About from "./page/about";
import Home2 from "./page/home2";
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Navbar />
      <Routes>
        {/* <Route path="/" element={<Splash />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home2 />} />
        <Route path="/about" element={<About />} />
        <Route path="/claims" element={<Repairs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/become-a-dealer" element={<Becomedealerpage />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/terms&conditions" element={<Terms />} />
        {/* <Route path="/blog" element={<Blogsec />} />
        <Route path="/blog1" element={<Blog1 />} />
        <Route path="/blog2" element={<Blog2 />} />
        <Route path="/blog3" element={<Blog3 />} />
        <Route path="/blog4" element={<Blog4 />} />
        <Route path="/blog5" element={<Blog5 />} />
        <Route path="/blog6" element={<Blog6 />} /> */}
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/products" element={<Products />} />
        <Route path="/reviews" element={<Reviews />} />
        {/* <Route path="/meet-the-team" element={<Team />} /> */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
